import { render } from "./Sidebar.vue?vue&type=template&id=4f8c7ee2&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=4f8c7ee2&lang=scss&scoped=true"

import exportComponent from "/home/daniel/code/myawu/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f8c7ee2"]])

export default __exports__